module.exports = __webpack_public_path__ + "img/83.605a83ac.jpg";